<template>
  <div class="alert-content">
    <transition-group name="slide" mode="out-in">
      <v-alert v-for="(alert, index) in alerts" :key="index" :value="alert.show" :class="alert.type" class="slide-alert"
        style="width: 420px; border-radius: 15px; opacity: 0.95; padding: 10px;" :close-text="alert.closeText"
        @input="hideAlert(index)" elevation="3" transition="scale-transition">
        <span class="time-stamp">
          <v-icon style="font-size: small; color: #fff;">fa-regular fa-clock</v-icon>
          {{ alert.dateStamp }}
        </span>
        <v-row no-gutters>
          <v-col cols="12" sm="2" md="2">
            <img :src="getIconSrc(alert.type)" class="icon-img" :alt="`${alert.type} icon`" />
          </v-col>
          <v-col cols="12" sm="9" md="9" class="text-message">
            <div v-html="alert.message"></div>
          </v-col>
          <v-col cols="12" sm="1" md="1" class="shrink">
            <v-icon @click="hideAlert(index)" color="white">fa-regular fa-circle-xmark</v-icon>
          </v-col>
        </v-row>
      </v-alert>
    </transition-group>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'AlertComponent',
  data() {
    return {
      alerts: [],
      isAlertActive: false,
      iconMap: {
        success: 'IconImg/check.png',
        error: 'IconImg/info.png',
        warning: 'IconImg/caution.png',
        info: 'IconImg/verified.png',
      },
    };
  },
  computed: {
    ...mapState('utils', ['alertToggle', 'alertProp']),
  },
  methods: {
    ...mapMutations('utils', ['SET_ALERT_TOGGLE']),
    getIconSrc(type) {
      return this.iconMap[type] || this.iconMap.info;
    },
    formatDate(date) {
      const pad = (num) => String(num).padStart(2, '0');
      const dd = pad(date.getDate());
      const mm = pad(date.getMonth() + 1);
      const yy = date.getFullYear().toString().slice(-2);
      const HH = pad(date.getHours());
      const ii = pad(date.getMinutes());
      const ss = pad(date.getSeconds());
      return `${dd}/${mm}/${yy} ${HH}:${ii}:${ss}`;
    },
    showAlert() {
  if (this.isAlertActive) return;

  this.isAlertActive = true;

  const alertObj = {
    show: true,
    type: this.alertProp.type,
    message: this.alertProp.message,
    closeText: 'Close',
    dateStamp: this.formatDate(new Date()),
  };

  this.alerts.push(alertObj);
  const index = this.alerts.length - 1;

  let timeout = 2000;
  if (this.alertProp.type === 'error' || this.alertProp.type === 'warning') {
    timeout = 10000;
  }

  setTimeout(() => {
    this.hideAlert(index);
    this.SET_ALERT_TOGGLE();
  }, timeout);
},

hideAlert(index) {
  // ป้องกัน error ถ้า index ไม่มี
  if (!this.alerts[index]) return;

  this.$set(this.alerts[index], 'show', false);
  setTimeout(() => {
    if (this.alerts[index]) this.alerts.splice(index, 1);
    this.isAlertActive = false;
  }, 500);
},
  },
  watch: {
    alertToggle(newVal) {
      if (newVal) {
        this.showAlert();
      }
    },
  },
};
</script>

<style scoped>
.alert-content {
  position: fixed;
  top: 4%;
  right: 20px;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.success {
  background: linear-gradient(90deg, rgba(156, 220, 120, 1) 9%, rgba(85, 209, 121, 1) 65%);
}

.error {
  background: linear-gradient(90deg, rgba(255, 171, 158, 1) 9%, rgba(255, 92, 92, 1) 55%);
}

.warning {
  background: linear-gradient(90deg, rgb(255, 231, 158) 9%, rgb(255, 171, 92) 55%);
}

.info {
  background: linear-gradient(90deg, rgb(158, 237, 255) 9%, rgb(92, 182, 255) 55%);
}

.icon-img {
  height: 48px;
  margin-right: 8px;
}

.text-message {
  align-content: center;
}

.time-stamp {
  color: #ffffffc2;
  font-size: x-small;
  position: absolute;
  right: 18px;
  bottom: 3px;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.4s;
}

.slide-enter,
.slide-leave-to {
  transform: translateY(-108%);
}
</style>